/**
 * Right-click uses on the roster-3 mobs (called from entities/mobUse.ts):
 * bowl / bucket / shears on a mooshroom, bucket on a goat, shears on a snow
 * golem, raw fish offered to a wary ocelot.
 */
import { I } from '../../game/itemIds';
import { isEmpty, type Stack } from '../../game/types';
import type { Mob } from '../mob';
import type { MobUseFx, MobUseWorld } from '../mobUse';
import { Goat, Mooshroom, Ocelot, SnowGolem } from './animals';

export function mobs3UseLikely(mob: Mob, held: Stack): boolean {
  if (isEmpty(held)) return false;
  const id = held.id;
  return (mob instanceof Mooshroom && (id === I.BOWL || id === I.BUCKET || id === I.SHEARS))
    || (mob instanceof Goat && id === I.BUCKET)
    || (mob instanceof SnowGolem && id === I.SHEARS)
    || (mob instanceof Ocelot && (id === I.COD || id === I.SALMON));
}

export function mobs3Use(world: MobUseWorld, mob: Mob, held: Stack): MobUseFx | null {
  const id = held.id;
  const toss = (out: Stack[], y: number): void => {
    for (const s of out) world.spawnItem(s, mob.x, mob.y + y, mob.z, (world.rnd() - 0.5) * 0.2, 0.1 + world.rnd() * 0.05, (world.rnd() - 0.5) * 0.2);
  };
  if (mob instanceof Mooshroom) {
    if (mob.baby) return null;
    if (id === I.BOWL) return { consume: 1, give: [I.MUSHROOM_STEW, 1, 0] };
    if (id === I.BUCKET) return { consume: 1, give: [I.MILK_BUCKET, 1, 0] };
    if (id === I.SHEARS) {
      const out = mob.shear();
      if (out.length === 0) return null;
      toss(out, 1);
      return { wear: 1 };
    }
    return null;
  }
  if (mob instanceof Goat && id === I.BUCKET) return mob.baby ? null : { consume: 1, give: [I.MILK_BUCKET, 1, 0] };
  if (mob instanceof SnowGolem && id === I.SHEARS) {
    if (mob.sheared) return null;
    toss(mob.shear(), 1.7);
    return { wear: 1 };
  }
  // a trusting ocelot takes fish as breeding food instead (breeding.ts)
  if (mob instanceof Ocelot && (id === I.COD || id === I.SALMON) && mob.offer(world.rnd)) return { consume: 1 };
  return null;
}
